import React from 'react';
import { CircularProgress, Grid } from '@mui/material';
export function showLoadingScreen() {
  return (
    <Grid
      container
      item
      direction={'row'}
      alignItems={'center'}
      justifyContent={'center'}
      style={{
        textAlign: 'center',
        height: '20vw',
        verticalAlign: 'middle',
      }}
    >
      <CircularProgress size={48} />
    </Grid>
  );
}
export function runLoading() {
  return (
    <Grid
      container
      item
      direction={'row'}
      alignItems={'center'}
      justifyContent={'center'}
      style={{
        textAlign: 'center',
        verticalAlign: 'middle',
        padding: '16px 0',
      }}
    >
      <CircularProgress size={40} />
    </Grid>
  );
}
